import { render, staticRenderFns } from "./lastReport.vue?vue&type=template&id=6c7bd38c&"
import script from "./lastReport.vue?vue&type=script&lang=js&"
export * from "./lastReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports